import React from 'react';
import { connect } from 'react-redux';

import FpTranslate from 'forepaas/translate';
import FpStandardLogin from './FpStandardLogin/FpStandardLogin.jsx';
import ProviderLogin from './ProviderLogin';
import { getCurrentBrand } from '@/helpers/brand';
import { MEMORY_STORE } from '@/helpers/constants/storage';

@connect((state) => ({
  show_goodbye_screen: state.session?.['show_goodbye_screen'] || false,
  currentBrand: state.memory?.[MEMORY_STORE.CURRENT_BRAND] || 'cloom',
}))
class FpLoginSelector extends React.Component {
  componentDidMount() {
    if (this.props.show_goodbye_screen) {
      // Brand is already stored in Redux (this.props.currentBrand)
      // Safe to clear storage now
      localStorage.clear();
      sessionStorage.clear();
    }
    // Note: Brand is detected from URL on login page, no need to save to storage
    // After login, brand will be set from tenant data via BrandManager component
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.show_goodbye_screen && this.props.show_goodbye_screen) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  redirectToLogin = () => {
    // Check if the brand was roomai, redirect to /roomai to preserve branding
    // Use brand from Redux props since sessionStorage has been cleared
    const brand = getCurrentBrand();
    if (brand === 'roomai') {
      window.location.href = '/roomai';
    } else {
      window.location.href = '/';
    }
  };

  // Check if the current URL is a provider login route
  isProviderLoginRoute() {
    const currentPath = window.location.pathname + window.location.hash;
    const providerLoginPattern = /\/login\/provider\/([^/\s?#]+)/;
    return providerLoginPattern.test(currentPath);
  }

  // Check if the current URL is a RoomAI login route
  // Requirements: 4_3
  isRoomAIRoute() {
    const pathname = window.location.pathname;
    const hash = window.location.hash;
    return pathname.includes('/roomai') || hash.includes('/roomai');
  }

  // Extract provider name from URL
  getProviderName() {
    const currentPath = window.location.pathname + window.location.hash;
    const providerLoginPattern = /\/login\/provider\/([^/\s?#]+)/;
    const match = currentPath.match(providerLoginPattern);
    return match ? match[1] : null;
  }

  renderLogoutPage() {
    // Get current brand for logout page from Redux (since sessionStorage is cleared)
    // Requirements: 4_2
    const brand = getCurrentBrand();
    const logoSrc = brand === 'roomai' ? '/assets/img/roomai-logo.png' : '/assets/img/cloom-logo.png';
    const logoAlt = brand === 'roomai' ? 'RoomAI Logo' : 'Cloom Logo';

    return (
      <div className={`new-login-container ${brand === 'roomai' ? 'brand-roomai' : 'brand-cloom'}`}>
        {/* Left Panel */}
        <div className="login-left-panel">
          <div className="logo-section">
            <div className="cloom-logo">
              <img src={logoSrc} alt={logoAlt} className="logo-image" />
            </div>
            {process.env.REACT_APP_ENV_TYPE !== 'prod' && (
              <div className="environment-text">{'開発環境'}</div>
            )}
          </div>
          <div className="version-info">Version: {process.env.REACT_APP_VERSION}</div>
        </div>
        {/* Right Panel */}
        <div className="login-right-panel">
          <div className="login-form-container">
            <h1 className="login-title">{FpTranslate('You successfully signed out')}</h1>
            <div className="form-description" style={{ marginBottom: 16 }}>
              <p className="form-description-text">{FpTranslate('It is recommended to now close all browser windows before leaving. You can also sign back in by clicking the button below.')}</p>
            </div>
            <div className="login-button-container">
              <button
                className="login-button"
                type="button"
                onClick={this.redirectToLogin}
              >
                {FpTranslate('Sign back in')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.show_goodbye_screen) {
      return this.renderLogoutPage();
    }

    // Get current brand for all login views
    const brand = getCurrentBrand();

    // Check if this is a provider-specific login route
    if (this.isProviderLoginRoute()) {
      const providerName = this.getProviderName();
      return <ProviderLogin providerName={providerName} brand={brand} />;
    }

    return <FpStandardLogin brand={brand} />
  }
}

export default FpLoginSelector;
